import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const ReferencesPage: FC<any> = (props) => {

  let {} = props

    return (
        <MainAsideMenuLayout>
            {/*<BackLinkLayout>*/}
                <div>References
                </div>
            {/*</BackLinkLayout>*/}
        </MainAsideMenuLayout>
    )
}

export default ReferencesPage;